import React, { useState } from "react";
import Slider from "react-slick";

const CarouselArrowButton = ({ dir, method }) => {
    return (
        <button className={`${dir} carousel_arrow`} onClick={() => method()}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.21 33.92">
                <g id="SP_design">
                    <g>
                        <rect x="20.67" y="0" width="3.77" height="3.77" />
                        <rect x="24.44" y="0" width="3.77" height="3.77" />
                        <rect x="15.51" y="3.77" width="3.77" height="3.77" />
                        <rect x="19.28" y="3.77" width="3.77" height="3.77" />
                        <rect x="10.32" y="7.54" width="3.77" height="3.77" />
                        <rect x="14.09" y="7.54" width="3.77" height="3.77" />
                        <rect x="5.18" y="11.31" width="3.77" height="3.77" />
                        <rect x="8.95" y="11.31" width="3.77" height="3.77" />
                        <rect x="0" y="15.07" width="3.77" height="3.77" />
                        <rect x="3.77" y="15.07" width="3.77" height="3.77" />
                        <rect x="5.18" y="18.84" width="3.77" height="3.77" />
                        <rect x="8.95" y="18.84" width="3.77" height="3.77" />
                        <rect x="10.32" y="22.61" width="3.77" height="3.77" />
                        <rect x="14.09" y="22.61" width="3.77" height="3.77" />
                        <rect x="15.51" y="26.38" width="3.77" height="3.77" />
                        <rect x="19.28" y="26.38" width="3.77" height="3.77" />
                        <rect x="20.67" y="30.15" width="3.77" height="3.77" />
                        <rect x="24.44" y="30.15" width="3.77" height="3.77" />
                    </g>
                </g>
            </svg>
        </button>
    );
};

const CarouselPrevButton = ({ method }) => {
    return <CarouselArrowButton dir="prev" method={method} />;
};

const CarouselNextButton = ({ method }) => {
    return <CarouselArrowButton dir="next" method={method} />;
};

// 検索結果表示カルーセルコンポーネントreact-slickパッケージを使ってる
export default function Carousel({
    itemList,
    settings,
    parrentClass,
    isArrowActiveClass,
}) {
    const [pickupSlider, setPickupSlider] = useState(undefined);
    const prev = () => {
        pickupSlider.slickPrev();
    };
    const next = () => {
        pickupSlider.slickNext();
    };
    return (
        <div
            className={`${isArrowActiveClass} ${parrentClass}_carousel carousel`}
        >
            <CarouselPrevButton method={prev} />
            <CarouselNextButton method={next} />
            <Slider {...settings} ref={(slider) => setPickupSlider(slider)}>
                {itemList}
            </Slider>
        </div>
    );
}
